<template>
  <div id="app">
    <navi></navi>
    <router-view/>
    <foot></foot>
  </div>
</template>

<script>
  import navi from '@/components/parts/navbar'
  import foot from '@/components/parts/footer'
  export default {
    components: {
      navi,
      foot
    },
    metaInfo: {
      titleTemplate: 'Fincor | %s ',
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  }
</script>
<style>

</style>
